// This route is required for regression test
export default function Echo(): JSX.Element {
  return <div className="pageContainer"></div>;
}
